import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrAccountDeletionBlocker.ts
var t = () => e("accountDeletionBlocker");
//#endregion
export { t as useTrAccountDeletionBlocker };
